<!DOCTYPE html>
@if (showPage()) {
  <app-datatable [identifier]="'latest-releases'" [cols]="cols" [rows]="rows" (onclickrowlink)="showDetails($event)" [isloading]="isLoading" [sortdata]="true"
  [isSortable]="false" (rowclickevent)="clickLatest($event)" (actionmenuevent)="actionMenuClicked($event)"></app-datatable>
} @else {
  <div id="catalog-overview-loading" class="ot-progress ot-progress--is-bouncer ot-progress--is-bouncer-big ot-progress--is-bouncer-has-text">
    <div class="ot-progress__outer">
      <div class="ot-progress__meter">
      </div>
    </div>
    <div class="ot-progress__text" i18n>Please wait while the manifest is updated...</div>
  </div>
}
